import React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';

interface Props {
  openBackdrop: boolean;
}

export default function LoadingBackdrop({ openBackdrop }: Props) {
  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={openBackdrop}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
